import React from 'react'
import './are-you-sure-delete-teacher-modal.css'

const AreYouSureDeleteTeacherModal = (props) => {

    const clickWrapprClose = (id) => {
        if(id === 'delete-teacher-modal-wrapper') {
            props.setDeleteModal(false)
        }
    }
    const makePointerLoading = () => {
        document.getElementById('delete-teacher-modal-wrapper').style.cursor = 'progress'
        document.getElementById('delete-teacher-yes').style.cursor = 'progress'
        props.deleteTheTeacher(props.teacher.TeacherID)
    }

    return(
        <div className="delete-teacher-modal-wrapper" id="delete-teacher-modal-wrapper" onClick={(e) => clickWrapprClose(e.target.id)}>
            <div className="delete-teacher-modal">
                <div className="delete-teacher-x-wrapper">
                    <div className="delete-teacher-x" onClick={() => props.setDeleteModal(false)}>x</div>
                </div>
                <h4>Are you sure you want to permanently delete <strong>{props.teacherName}</strong> from the database and websites?</h4>
                <div className="delete-teacher-button-wrapper">
                    <div className="delete-teacher-no" onClick={() => props.setDeleteModal(false)}>No</div>
                    <div className="delete-teacher-yes" id="delete-teacher-yes" onClick={() => makePointerLoading()}>Delete</div>
                </div>
            </div>
        </div>
    )
}
export default AreYouSureDeleteTeacherModal